module.exports = __webpack_public_path__ + "static/agent-app-icon-not-shared-a64d92147ce49f003d4e241f7bf261e2.svg";